/**
 * A method that returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/noop.js
 ** module id = 62
 ** module chunks = 0
 **/